export default __webpack_public_path__ + "static/media/pic2.5818c3d8.jpg";